module.exports = __webpack_public_path__ + "static/media/tartine-home.4d5e4083.png";